import React from "react";
import { Box, Typography, Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

export default function DistributorDetails({ availableBalance, totalReceived, totalDistributed, onSendClick }) {
  const classes = useStyles();
  
  return (
    <Box className={classes.statsContainer}>
      <Box className={classes.statRow}>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            Received
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {totalReceived}
          </Typography>
        </Box>
        <Box className={classes.statItem}>
          <Typography variant="body2" className={classes.statLabel}>
            Distributed
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {totalDistributed}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.statRowCentered}>
        <Box className={classes.statItemCentered}>
          <Typography variant="body2" className={classes.statLabel}>
            Balance
          </Typography>
          <Typography variant="h5" className={classes.statValue}>
            {availableBalance}
          </Typography>
        </Box>
      </Box>
      <Box className={classes.buttonContainer}>
        <Button
          variant="contained"
          color="primary"
          onClick={onSendClick}
          className={classes.sendButton}
        >
          <Typography className={classes.buttonLabel}>Send</Typography>
        </Button>
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  statsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    width: "100%",
  },
  statRow: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(2),
    width: "100%",
  },
  statRowCentered: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    width: "100%",
  },
  statItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1.5),
    backgroundColor: "#f5f5f5",
    borderRadius: theme.shape.borderRadius,
    flex: 1,
  },
  statItemCentered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(1.5),
    backgroundColor: "#f5f5f5",
    borderRadius: theme.shape.borderRadius,
    minWidth: "calc(50% - 8px)",
  },
  statLabel: {
    color: "rgb(135, 131, 131)",
    marginBottom: theme.spacing(0.5),
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  statValue: {
    color: "rgb(100, 100, 100)",
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    width: "100%",
  },
  sendButton: {
    minWidth: 150,
  },
  buttonLabel: {
    fontWeight: "bold",
  },
}));
